import { useState, useEffect } from 'react';
import { Row, Col, Button, Label, Spinner } from 'reactstrap';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';

const WinterGrazing = ({ handleWizardChanged, handleMoveToNextPage, handleWizardChangedBack }) => {
    const roleName = localStorage.getItem("roleName"); const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [loading, setLoading] = useState(true);
    const [wintergrazing, setwintergrazing] = useState({
        outlineList: [], itemList: [], itemTypes: [], Section: 'WinterGrazing', SectionName: 'Intensive Winter Grazing',
        itemFieldTypes: [], waterwayWidthList: [], percentageFencedList: [], averageRiparianMarginPlantedList: [], SectionObj: {}, isWizardCompleted: false
    });

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const OnPageload = async (e) => {
        try {
            var section = window.wizardDetails.filter(x => x.controllerName == 'wintergrazing');
            if (section.length > 0) {
                setIsNextButtonVisible(section[0].isSectionCompleted);
            }
            setwintergrazing({ ...wintergrazing, isWizardCompleted: false })
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    }
    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{wintergrazing.SectionName}</h3></Col>
                {wintergrazing.isWizardCompleted != true && !loading &&
                    <Col>
                        {(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => handleWizardChanged(wintergrazing.Section)}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        {roleName != 'SWNZ Admin' && saveRightsForNonItemFieldsAndTables == 'false' && isNextButtonVisible &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => handleMoveToNextPage(wintergrazing.Section)}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        <Button className="float-end btn-next-page" onClick={(section) => handleWizardChangedBack(wintergrazing.Section)}>Back <FaChevronLeft /> </Button>
                    </Col>
                }
            </Row>
            {loading ? <Spinner color="success"> Loading... </Spinner> :
                <Row xs="2">
                    <Col>
                        <Label className="showlayer">Coming Soon</Label>
                    </Col>
                </Row>
            }

        </div>
    )
}
export default WinterGrazing;